import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

/*
 * Wrapper Element Animations
 */
const WRAPPER_ELEMENT_X_OFFSET = 100;
const ANIMATION_DURATION = 0.75;

export const wrapperElementMotionProps: MotionProps = {
  initial: 'hidden',
  variants: {
    hidden: buildHiddenVariant({ x: WRAPPER_ELEMENT_X_OFFSET }),
    visible: buildVisibleVariant({
      transition: {
        duration: ANIMATION_DURATION,
      },
    }),
  },
  viewport: { once: true },
  whileInView: 'visible',
};
